const selectBoxHighlightApp = {
  init() {
    this.frequencyLabels = document.querySelectorAll('.productSection__frequencyRadioGroup label');
    this.selectBoxDiv = document.querySelector('.product_variant--background');
    this.selectBox = document.querySelector('.productSection__variant select');
    if (!this.selectBoxDiv || !this.frequencyLabels.length) return;
    this.setupEventListeners();  
    document.addEventListener('DOMContentLoaded', this.highlightEffect.bind(this));
  },

  setupEventListeners() {
    this.frequencyLabels.forEach(label => label.onclick = this.handleLabelClick.bind(this)) 
  },

  handleLabelClick() {
    if (this.selectBox.value !== '0') return;
    this.highlightEffect();
  },
	
  highlightEffect() {
    this.highlightSelectBox();
    setTimeout(() => {
      this.unhighlightSelectBox();
    }, 3000)
  },
  
  highlightSelectBox() {
    this.selectBoxDiv.classList.add('highlighted-background');
  },
  
  unhighlightSelectBox() {
    this.selectBoxDiv.classList.remove('highlighted-background');	
  }
	
}

selectBoxHighlightApp.init();


const currencySymbolApp = {
  init() {
    this.priceMoneyBoards = document.querySelectorAll('.productSection__price .productSection__money');
    if (!this.priceMoneyBoards.length) return;
    document.addEventListener('DOMContentLoaded', this.action.bind(this));
  },
	
  action() {
    this.priceMoneyBoards.forEach(board => this.replaceCurrencyTextWithSymbol(board));
  },
	
  replaceCurrencyTextWithSymbol(x) {
    x.innerHTML = x.innerHTML.replace('NIS', '₪');
    if (document.documentElement.lang === 'he') return;
    let b = x.innerHTML.split(' ').filter(x => !!x && x !== '\n');
    let c = [b[1], b[0], ...b.slice(2)];
    x.innerHTML = c.join(' ');
  }
}

currencySymbolApp.init();


// const redirectionApp = {

//   init() {
//     const redirectedOnce = sessionStorage.getItem('redirected') || false;
//     if (redirectedOnce) return;
//     this.lang = '/he';
//     this.setupRedirection();
//   },

//   setupRedirection() {
//    sessionStorage.setItem('redirected', 'true');
//    const { protocol, host, pathname } = window.location;
//    if (pathname.includes(this.lang)) return;
//    const url = '/he' + pathname;
//    window.location.href = url;
//   }
// }

// redirectionApp.init();






				


